import { Plugin } from '@tiptap/pm/state';
import { isInlineSwatchDecorationTarget } from './inlineSwatchUtils';

export function inlineSwatchDragHandler(): Plugin {
    return new Plugin({
        props: {
            handleDOMEvents: {
                dragstart: (view, event) => {
                    if (!isInlineSwatchDecorationTarget(event.target)) return false;

                    event.stopPropagation();

                    const spanElement = event.target as HTMLElement;

                    const color = spanElement.style.getPropertyValue('--color') || '#000000';
                    event.dataTransfer?.setData('text/plain', color);

                    return true;
                },
            },
        },
    });
}
